var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1718781126291,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2013,
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M795.128 246.24C745.64 129.752 631.624 52.744 505.832 52.744c-171.656 0-311.6 139.832-314.384 311.784C83.504 379.464 0 474.928 0 590.144c0 125.544 100.184 227.688 223.336 227.688h76.984a30.32 30.32 0 0 0 30.344-30.344 30.32 30.32 0 0 0-30.344-30.344h-76.984c-89.696 0-162.648-74.904-162.648-167 0-93.608 70.408-166.944 160.312-166.944a30.344 30.344 0 0 0 30.312-29.304l0.768-23.056c0-141.936 113.84-257.408 253.76-257.408 106.408 0 202.448 68.568 238.976 170.648a30.344 30.344 0 0 0 25.512 19.976c110.016 11.112 192.984 108.304 192.984 226.032 0 125.184-95.768 227.064-213.464 227.064H718.08a30.32 30.32 0 0 0-30.344 30.344 30.32 30.32 0 0 0 30.344 30.344h31.768c151.176 0 274.152-129.08 274.152-287.752 0-142.36-97.136-261.096-228.872-283.848z",
    fill: "#838384",
    "p-id": 2014
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M545.664 575.528a29.88 29.88 0 0 0-9.896-6.576 30.128 30.128 0 0 0-23.168 0 29.84 29.84 0 0 0-9.896 6.576L393.208 684.96a30.336 30.336 0 1 0 42.912 42.904l57.72-57.696v270.744c0 16.776 13.568 30.344 30.344 30.344s30.344-13.568 30.344-30.344V670.2l57.664 57.664a30.32 30.32 0 0 0 42.896 0 30.32 30.32 0 0 0 0-42.904L545.664 575.528z",
    fill: "#838384",
    "p-id": 2015
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIcon);
export default __webpack_public_path__ + "static/media/update_Icon.d7e4b06c02236587a552c12c41e206bc.svg";
export { ForwardRef as ReactComponent };